export default "__VITE_ASSET__7fad56c4__"